import React from "react";
import { map } from "lodash";
import {
  Container,
  Bloc,
  StepContainer,
  TextContainer,
  Title,
  Step,
} from "./styled-components";
import Text from "../text";

const ProcedureBloc = () => {
  const options = {
    title: "Quelles sont les démarches préalables ?",
    steps: [
      {
        title: "Écrire à l'organisme avec lequel vous avez un problème",
      },
      {
        title:
          "Si l’organisme auquel vous avez écrit ne répond pas ou que vous n'êtes pas d'accord avec sa réponse, vous pouvez alors saisir le Défenseur des droits.",
      },
    ],
  };

  return (
    <Container>
      <Title>
        <Text size="24px" lineHeight="24px" weight={700}>
          {options.title}
        </Text>
      </Title>
      {map(options.steps, ({ title }, index) => (
        <Bloc key={index}>
          <StepContainer>
            <Step>
              <Text color="blue" size="24px" weight={700}>
                {index + 1}
              </Text>
            </Step>
          </StepContainer>
          <TextContainer>
            <Text size="18px" lineHeight="20px" weight={600}>
              {title}
            </Text>
          </TextContainer>
        </Bloc>
      ))}
    </Container>
  );
};

export default ProcedureBloc;
